"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var MusicItem_1 = __importDefault(require("../components/MusicItem"));
var MusicPage_1 = __importDefault(require("../components/MusicPage"));
var graphql_1 = require("../generated/graphql");
function Loading() {
    return react_1.default.createElement("p", null, "Loading...");
}
function Error() {
    return (react_1.default.createElement("p", null,
        "Couldn't load. Check me out on ",
        react_1.default.createElement("a", { href: "https://www.last.fm/user/cmarcksthespot" }, "last.fm"),
        " instead"));
}
var imageSortOrder = ['extralarge', 'large', 'medium', 'small'];
var imageSort = function (a, b) {
    return imageSortOrder.indexOf(a.size) - imageSortOrder.indexOf(b.size);
};
function PageContents() {
    var _a = (0, graphql_1.useTopTracksQuery)(), loading = _a.loading, error = _a.error, data = _a.data;
    if (loading)
        return react_1.default.createElement(Loading, null);
    if (error || !data || !data.user)
        return react_1.default.createElement(Error, null);
    var user = data.user;
    return (react_1.default.createElement("div", { className: "row", style: { justifyContent: 'center' } }, user.topTracks.map(function (_a) {
        var album = _a.album, url = _a.url, name = _a.name, artist = _a.artist;
        var albumImages = album ? album.image.sort(imageSort).map(function (i) { return i.url; }) : [];
        var images = __spreadArray(__spreadArray([], albumImages.filter(function (i) { return i.length > 0; }), true), [
            '/packages/site/static/theme/images/overlay.png',
        ], false);
        return react_1.default.createElement(MusicItem_1.default, { images: images, url: url, title: name, subtitle: artist.name, key: name });
    })));
}
function Tracks() {
    return (react_1.default.createElement(MusicPage_1.default, { category: "tracks" },
        react_1.default.createElement(PageContents, null)));
}
exports.default = Tracks;
